<template>
<div class="chapter">
<div class="inner_page">
<div id="Not-Just-the-Bosss-Plaything.html" xml:lang="en-US">
<div class="story">
<p class="pl-title"><a id="Anchor-1">Not Just the Boss’s Plaything</a></p><a id="Anchor-1">
</a></div><a id="Anchor-1">
</a></div><a id="Anchor-1">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// NotJusttheBosssPlaything.vue?11759ac6